<template>
  <div class="originalty">
    <el-row :gutter="10">
      <el-col :span="6">
        <el-input
          placeholder="请输入搜索内容"
          v-model="searchForm.ideaName"
          class="input-with-select"
          clearable
        >
          <div slot="prepend">创意名称</div>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-select
          style="width: 100%"
          v-model="searchForm.status"
          placeholder="状态"
          clearable
        >
          <el-option
            v-for="(item, index) in originalityStatus"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select
          v-model="searchForm.appIdList"
          multiple
          clearable
          collapse-tags
          filterable
          placeholder="推广应用"
          style="width: 100%"
        >
          <el-option
            v-for="item in promoteAppList"
            :key="item.appId"
            :label="item.appName"
            :value="item.appId"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="searchForm.costType" placeholder="出价模式">
          <el-option
            v-for="item in ideaCostTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="6">
      <el-col :span="8">
        <el-row type="flex" align="middle">
          <span style="white-space: nowrap"> 提交日期：</span>
          <el-date-picker
            type="daterange"
            range-separator="至"
            v-model="searchForm.date"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-row>
      </el-col>
      <el-col :span="4"
        ><el-button type="primary" icon="el-icon-search" @click="searchFn()"
          >查询</el-button
        ></el-col
      >
    </el-row>
    <PageTable
      id="statisticsTable"
      class="pageTable"
      :columns="initcolumns"
      :tableData="tableData"
      @page-change="handleChangePage"
    >
      <template #operation="{ row }">
        <el-button
          v-has="'review'"
          type="text"
          :disabled="row.status !== 2"
          @click="toExamine(row)"
          >审核</el-button
        >
        <el-button type="text" v-has="'history'" @click="showHistory(row)"
          >历史记录</el-button
        >
      </template>
      <template #status="{ row }">
        <el-tag
          size="small"
          class="cursor"
          :type="row.status | tagType(originalityStatus)"
          v-if="!row.remarks || row.remarks == ''"
        >
          {{ row.status | filterExamineName }}
        </el-tag>
        <el-popover trigger="click" v-else>
          <p
            style="
              max-width: 150px;
              word-wrap: break-word;
              word-break: break-all;
            "
          >
            审核意见：{{ row.remarks }}
          </p>
          <el-tag
            size="small"
            class="cursor"
            slot="reference"
            :type="row.status | tagType(originalityStatus)"
          >
            {{ row.status | filterExamineName }}
          </el-tag>
        </el-popover>
      </template>

      <template #showType="{ row }">
        <span>{{ row.showType | filterShowTypeName }}</span>
      </template>
      <template #costType="{ row }">
        <span>{{ row.costType | filterCostTypeName }}</span>
      </template>
    </PageTable>
    <examineDrawer
      @submit="initList"
      :editData="editData"
      v-model="examineDialog"
    ></examineDrawer>
    <historyDrawer
      @handleChangePage="handleChangePageHistory"
      :editData="editData"
      :historyLogs="historyLogs"
      v-model="historyDialog"
    ></historyDrawer>
  </div>
</template>

<script>
import examineDrawer from "./examineDrawer.vue";
import historyDrawer from "./historyDrawer.vue";
import {
  getIdeaAuditList,
  getIdeaLog,
  getPromoteAppList,
} from "@/common/js/api";
import moment from "moment";
import PageTable from "@/components/PageTableSort";
import {
  originalityShowTypes,
  originalityStatus,
  ideaCostTypeList,
} from "@/common/constant/constant.js";

export default {
  components: {
    examineDrawer,
    historyDrawer,
    PageTable,
  },
  data() {
    let end = moment(new Date()).format("YYYY-MM-DD");
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    start = moment(start).format("YYYY-MM-DD");
    return {
      searchForm: {
        ideaName: "",
        status: "",
        appIdList: [],
        costType: 0,
        pageIndex: 1,
        pageSize: 10,
        date: [start, end],
      },
      initcolumns: [
        { key: "ideaName", label: "创意名称" },
        // { slot: "showType", label: "展示类型" },
        { key: "planName", label: "推广计划" }, //?
        { key: "groupName", label: "推广组" },
        { key: "appName", label: "所属应用" },
        { key: "developerName", label: "所属开发者" },
        { key: "budgetAmount", label: "投放预算" },
        { key: "country", label: "投放国家" },
        { slot: "costType", label: "出价模式" },
        { key: "onceAmount", label: "出价价格" },
        { slot: "status", label: "审核状态" },
        { key: "resolveUserName", label: "审核员" },
        { slot: "operation", label: "操作" },
      ],
      promoteAppList: [],
      ideaCostTypeList,
      columns: [],
      tableData: {
        list: [],
        size: 10,
        page: 1,
        total: 10,
      },
      examineDialog: false,
      editData: {},
      historyDialog: false,
      historyLogs: {},
      originalityStatus,
    };
  },
  mounted() {
    this.initList();
    this.loadPromoteAppList();
  },
  filters: {
    filterExamineName(val) {
      let sec = originalityStatus.find((a) => a.value === val);
      return sec ? sec.label : "";
    },
    filterShowTypeName(val) {
      let sec = originalityShowTypes.find((a) => a.value === val);
      return sec ? sec.label : "";
    },
    filterCostTypeName(val) {
      let sec = ideaCostTypeList.find((a) => a.value === val);
      return sec && val !== 0 ? sec.label : "-";
    },
  },
  methods: {
    async initList(query) {
      const { date, ...rest } = this.searchForm;
      const params = {
        ...rest,
        ...query,
      };
      if (date) {
        params.submitStart = date[0];
        params.submitEnd = date[1];
      }
      if (params.status === "") params.status = -1;
      let res = await getIdeaAuditList(params);
      this.tableData.list = res.data.ideaList;
      this.tableData.total = res.data.count;
      this.tableData.page = this.searchForm.pageIndex;
    },
    async loadPromoteAppList() {
      try {
        let res = await getPromoteAppList({});
        if (res && res.data) {
          this.promoteAppList =
            res.data.appList || res.data.list || res.data || [];
        }
      } catch (e) {
        console.error("加载推广应用列表失败", e);
      }
    },
    handleChangePage({ page, size }) {
      this.searchForm.pageIndex = page;
      this.searchForm.pageSize = size;
      this.initList();
    },
    toExamine(row) {
      this.editData = row;
      this.examineDialog = true;
    },
    async showHistory(row) {
      let res = await getIdeaLog({
        pageIndex: 1,
        pageSize: 10,
        ideaId: row.ideaID,
      });
      if (!res) return;
      this.historyLogs = {
        list: res.data.respList,
        total: res.data.total,
      };
      this.editData = row;
      this.historyDialog = true;
    },
    async handleChangePageHistory({ page, size }) {
      let res = await getIdeaLog({
        pageIndex: page,
        pageSize: size ? size : 10,
        ideaId: this.editData.ideaID,
      });
      if (!res) return;
      this.historyLogs = {
        list: res.data.respList,
        total: res.data.total,
      };
    },
    searchFn() {
      this.searchForm.pageIndex = 1;
      this.initList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../common/css/common.scss";
.originalty {
  .seriesLabel {
    height: 32px;
  }
  /deep/.el-input-group__prepend {
    background: #fff;
    width: 80px;
  }
  /deep/.el-date-editor--date {
    width: 100%;
  }
}
</style>
